/**
 * @generated SignedSource<<0f00a0550440fd5a231d2ad779136209>>
 * @relayHash ef9f01608fec11f212b113abdf87d7f3
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ef9f01608fec11f212b113abdf87d7f3

import { ConcreteRequest } from 'relay-runtime';
export type GenerateContraMagicProfileSuggestionsInput = {
  whatMakesYouUnique: string;
  whatServicesDoYouOffer: string;
};
export type useProfileMagicMutationsGenerateProfileSuggestionsMutation$variables = {
  input: GenerateContraMagicProfileSuggestionsInput;
};
export type useProfileMagicMutationsGenerateProfileSuggestionsMutation$data = {
  readonly generateContraMagicProfileSuggestions: {
    readonly bioRequestId: string | null;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }> | null;
    readonly oneLinerRequestId: string | null;
    readonly projectRequestId: string | null;
    readonly serviceRequestId: string | null;
  };
};
export type useProfileMagicMutationsGenerateProfileSuggestionsMutation = {
  response: useProfileMagicMutationsGenerateProfileSuggestionsMutation$data;
  variables: useProfileMagicMutationsGenerateProfileSuggestionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bioRequestId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oneLinerRequestId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectRequestId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceRequestId",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useProfileMagicMutationsGenerateProfileSuggestionsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GenerateContraMagicProfileSuggestionsPayload",
        "kind": "LinkedField",
        "name": "generateContraMagicProfileSuggestions",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useProfileMagicMutationsGenerateProfileSuggestionsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GenerateContraMagicProfileSuggestionsPayload",
        "kind": "LinkedField",
        "name": "generateContraMagicProfileSuggestions",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v8/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ef9f01608fec11f212b113abdf87d7f3",
    "metadata": {},
    "name": "useProfileMagicMutationsGenerateProfileSuggestionsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3808923c9249b962a66057f6bf4c4fb0";

export default node;
